import { AnyHandler, SimpleHandler } from 'app/types/handlers';
import { SupplementalAttribute } from 'app/types/project-config';
import { ConfigAttribute, AttributeInputType, AttributeInfo, AttributeId, AttributeFeatureType } from '../../types/project-config';
import { ChangeDetectionStrategy, Component, Input, OnInit, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { Project } from 'app/model/project';

@Component({
	selector: 'app-attribute-selector',
	templateUrl: './attribute-selector.component.html',
	styleUrls: ['./attribute-selector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttributeSelectorComponent implements OnInit {

	private _project?: Project;
	private _ready = false;

	private _selected?: AttributeId;
	@Input()
	public set selectedAttribute(attribute: AttributeId | undefined) {
		this._selected = attribute;;
		this.Refresh();
	}
	public get selectedAttribute(): AttributeId {
		if (!this._selected) return 0;
		return this._selected;
	}
	@Output()
	public selectedAttributeChange = new EventEmitter<AttributeId | undefined>();

	@Input()
	public set project(prj: Project | undefined) {
		this._project = prj;
		this.cdr.markForCheck();
		this.Refresh();
	}
	public get project(): Project | undefined {
		return this._project;
	}

	private _attribute?: AttributeId;
	@Input()
	public set attribute(attr: AttributeId | undefined) {
		this._attribute = attr;
		if (attr !== undefined) {
			if (!this.project) {
				this.Defer(() => {
					this.attribute = attr;
				});
				return;
			}
			const attribute = this.project.GetAttributeById(attr);
			if (!!attribute) {
				const featureType = this.project.GetFeatureType(attr);
				this._featureType = !!featureType ? featureType : undefined;
			}
		}
		this.Refresh();
	}
	public get attribute(): AttributeId | undefined {
		return this._attribute;
	}

	private _featureType?: AttributeFeatureType;
	@Input()
	public set featureType(type: AttributeFeatureType | undefined) {
		this._featureType = type;
		this.Refresh();
	}
	public get featureType(): AttributeFeatureType | undefined {
		return this._featureType;
	}
	public get attributes(): Array<ConfigAttribute | SupplementalAttribute> {
		if (!(this._project && this._project.config) || !this._featureType) {
			return [];
		}
		return this._project.config.attributes[this._featureType];
	}

	constructor(private cdr: ChangeDetectorRef) { }

	ngOnInit(): void {
		this._ready = true;

	}
	Refresh() {
		if (this._ready) {
			this.cdr.detectChanges();
		}
	}
	AttributeSelected() {
		window.requestAnimationFrame(() => {
			this.NotifyListeners();
		});
	}
	NotifyListeners() {
		this.selectedAttributeChange.emit(this.selectedAttribute);
	}
	Defer(handler: SimpleHandler) {
		handler();
	}
}
